import React from 'react'
import { Field } from 'formik'
import FormField from 'components/form-components/FormField'
import { formConfig } from './config'
import FormLabel from '../FormLabel'

const DefaultField = ({ name }) => (
  <>
    <FormLabel text={formConfig[name].label} />
    <Field
      name={formConfig[name].name}
      type={formConfig[name].type}
      placeholder={
        formConfig[name].placeholder || `Enter ${formConfig[name].label}`
      }
      component={FormField}
    />
  </>
)
export default DefaultField
